<template>
	<v-dialog v-model="showPerfil" persistent max-width="70vw" scrollable="">
		<v-card height="90vh" max-height="600px" class="teste">
			<v-toolbar flat :color="this.$store.state.title == 'Calendario' ? this.$store.state.corEvento : cor"></v-toolbar>
			<!-- menu lateral -->
			<v-card-text>
				<v-container>
					<v-tabs vertical class="pa-1 ma-0">
						
						<!-- foto perfil -->
						<v-avatar class="mx-auto profile" color="grey" size="182" tile>
							<v-img height="200" :src="iniciado.imagem"></v-img>
						</v-avatar>
						<!-- <input type="file" ref="file" @change="onFileSelected" style="display:none" />
						<v-btn small v-if="!salvarImagem" color="primary my-4" @click="launchFilePicker()">Alterar imagem</v-btn>
						<v-btn small v-else color="primary my-4" @click="uploadImg">Salvar imagem</v-btn> -->
						
						<!-- itens menu lateral -->
						<v-tab v-if="!habilitarEdicao" class="mt-4" @click.stop="mudarAba('iniciado')">
							<v-icon left>mdi-account</v-icon>Perfil
						</v-tab>
						<v-tab v-else class="mt-4" @click.stop="mudarAba('iniciado')">
							<v-icon left>mdi-account</v-icon>Dados Pessoais
						</v-tab>
						
						<v-tab v-if="!habilitarEdicao" @click.stop="mudarAba('graus')">
							<v-icon left>mdi-account</v-icon>Passagens de grau
						</v-tab>
						<v-tab v-else @click.stop="mudarAba('graus')">
							<v-icon left>mdi-account</v-icon>Endereço
						</v-tab>
						
						<v-tab v-if="!habilitarEdicao" @click.stop="mudarAba('clas')">
							<v-icon left>mdi-account</v-icon>Historico de clãs
						</v-tab>
						<v-tab v-else @click.stop="mudarAba('clas')">
							<v-icon left>mdi-account</v-icon>Outros Dados
						</v-tab>
						
						<v-tab v-if="!habilitarEdicao" @click.stop="mudarAba('titulos')">
							<v-icon left>mdi-account</v-icon>Títulos
						</v-tab>
						<v-tab @click.stop="mudarAba('acessos')">
							<v-icon left>mdi-account</v-icon>Acessos
						</v-tab>						

						<!-- abas perfil -->
						<v-tab-item v-if="!habilitarEdicao">
							<v-container>
								<Iniciado :dados="dadosIniciado"/>
							</v-container>
						</v-tab-item>
						<v-tab-item v-else>
							<v-container>
								<EditarPerfil :dados="dadosIniciado" :paises="paises"/>
							</v-container>
						</v-tab-item>
						
						<!-- abas passagem de grau -->
						<v-tab-item v-if="!habilitarEdicao">
							<v-container>
								<Passagens :passagens="dadosIniciado" />
								<v-dialog v-model="editarPassagem" :close-on-content-click="false" max-width="480" scrollable>
									<v-card color="rgba(255,255,255,1)" height="100%" width="100%" tile>
										<v-toolbar dense flat color="primary"></v-toolbar>
										<v-card-text>
											<v-container>
												<v-row>
													<v-col class="" cols="12">
														<v-text-field label="Grau" v-model="itemPassagem.grau" outlined readonly ></v-text-field>
													</v-col>
													<v-col cols="12">
													<v-menu ref="abrirDataPicker" v-model="abrirDataPicker" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
														<template v-slot:activator="{ on }">
															<v-text-field label="Data Passagem" v-model="dataPassagemFormatada" v-on="on" outlined></v-text-field>
														</template>
														<v-date-picker locale="pt-br" v-model="dataPassagem" no-title @input="abrirDatePicker = false"></v-date-picker>
													</v-menu> 
													</v-col>
												</v-row>
											</v-container>
										</v-card-text>
										<v-divider></v-divider>
										<v-card-actions>
											<v-spacer></v-spacer>
											<v-btn @click="salvarPassagemGrau" text color="primary">Salvar</v-btn>
											<v-btn @click="editarPassagem = false" text color="primary">Cancelar</v-btn>
										</v-card-actions>
									</v-card>
								</v-dialog>
								<v-dialog v-model="excluirPassagem" :close-on-content-click="false" max-width="480" scrollable>
									<v-card color="rgba(255,255,255,1)" height="100%" width="100%" tile>
										<v-toolbar flat dense color="primary"></v-toolbar>
										<v-card-text>
											<v-container>
												<v-row>
													<v-col class="" cols="12">
														<p>Deseja realmente excluir a passagem de {{itemPassagem.grau}} grauº?</p>
													</v-col>
												</v-row>
											</v-container>
										</v-card-text>
										<v-divider></v-divider>
										<v-card-actions>
											<v-spacer></v-spacer>
											<v-btn @click="excluirPassagemGrau" text color="primary">Confirmar</v-btn>
											<v-btn @click="excluirPassagem = false" text color="primary">Cancelar</v-btn>
										</v-card-actions>
									</v-card>
								</v-dialog>
								<v-dialog v-model="inserirNovoGrau" :close-on-content-click="false" max-width="480" scrollable="">
									<v-card color="rgba(255,255,255,1)" height="100%" width="100%" tile>
										<v-toolbar dense flat color="primary">
										</v-toolbar>
										<v-card-text>
											<v-container>
												<v-row>
													<v-col class="" cols="12">
														<p>Você irá alterar o iniciado {{iniciado.dados.nome}} para o {{novoGrau}}º grau.</p>
													</v-col>
													<v-col cols="12">
														<v-menu ref="abrirDataPicker" v-model="abrirDataPicker" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
															<template v-slot:activator="{ on }">
																<v-text-field label="Data Passagem" v-model="dataPassagemFormatada" v-on="on" outlined></v-text-field>
															</template>
															<v-date-picker locale="pt-br" v-model="dataPassagem" no-title @input="abrirDatePicker = false"></v-date-picker>
														</v-menu> 
													</v-col>
												</v-row>
											</v-container>
										</v-card-text>
										<v-divider></v-divider>
										<v-card-actions>
											<v-spacer></v-spacer>
											<v-btn @click="salvarNovoGrau" text color="primary">Confirmar</v-btn>
											<v-btn @click="inserirNovoGrau = false" text color="primary">Cancelar</v-btn>
										</v-card-actions>
									</v-card>
								</v-dialog>
							</v-container>
						</v-tab-item>
						<v-tab-item v-else>
							<v-card-text>
								<Endereco />
							</v-card-text>
						</v-tab-item>
						

						<!-- abas historico de clas -->
						<v-tab-item v-if="!habilitarEdicao">
							<v-card-text>
								<Clas :clas="dadosIniciado"/>
								<v-dialog v-model="editarHistoricoCla" :close-on-content-click="false" max-width="480" scrollable="">
									<v-card color="rgba(255,255,255,1)" height="100%" width="100%" tile>
										<v-toolbar dense flat color="primary"></v-toolbar>
										<v-card-text>
											<v-container>
												<v-row>
													<v-col class="" cols="12">
														<v-select item-text="nome" item-value="id" :items="this.listaClas" v-model="itemHistoricoCla.id_cla" label="Clã" outlined></v-select>
													</v-col>
													<v-col cols="12">
													<v-menu ref="abrirDataPicker" v-model="abrirDataPicker" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
														<template v-slot:activator="{ on }">
															<v-text-field label="Data Passagem" v-model="dataHistoricoFormatada" v-on="on" outlined></v-text-field>
														</template>
														<v-date-picker locale="pt-br" v-model="dataHistorico" no-title @input="abrirDatePicker = false"></v-date-picker>
													</v-menu> 
													</v-col>
												</v-row>
											</v-container>
										</v-card-text>
										<v-divider></v-divider>
										<v-card-actions>
											<v-spacer></v-spacer>
											<v-btn @click="salvarHistoricoCla" text color="primary">Salvar</v-btn>
											<v-btn @click="editarHistoricoCla = false" text color="primary">Cancelar</v-btn>
										</v-card-actions>
									</v-card>
								</v-dialog>
								<v-dialog v-model="excluirHistorico" :close-on-content-click="false" max-width="480" scrollable>
									<v-card color="rgba(255,255,255,1)" height="100%" width="100%" tile>
										<v-toolbar dense flat color="primary"></v-toolbar>
										<v-card-text>
											<v-container>
												<v-row>
													<v-col class="" cols="12">
														<p>Deseja realmente excluir a mudança para o clã {{itemHistoricoCla.nome}}?</p>
													</v-col>
												</v-row>
											</v-container>
										</v-card-text>
										<v-divider></v-divider>
										<v-card-actions>
											<v-spacer></v-spacer>
											<v-btn @click="excluirHistoricoCla" text color="primary">Confirmar</v-btn>
											<v-btn @click="excluirHistorico = false" text color="primary">Cancelar</v-btn>
										</v-card-actions>
									</v-card>
								</v-dialog>
								<v-dialog v-model="inserirHistoricoCla" :close-on-content-click="false" max-width="480" scrollable="">
									<v-card color="rgba(255,255,255,1)" height="100%" width="100%" tile>
										<v-toolbar dense flat color="primary"></v-toolbar>
										<v-card-text>
											<v-container>
												<v-row>
													<v-col class="" cols="12">
														<p>Você irá mudar o iniciado {{iniciado.dados.nome}} para um novo clã.</p>
														<p>Selecione um novo clã e informe a data da mudança.</p>
													</v-col>
													<v-col cols="12">
														<v-select item-text="nome" item-value="id" :items="this.listaClas" v-model="itemHistoricoCla.novoCla" label="Clã" outlined></v-select>
													</v-col>
													<v-col cols="12">
														<v-menu ref="abrirDataPicker" v-model="abrirDataPicker" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
															<template v-slot:activator="{ on }">
																<v-text-field label="Data Mudança" v-model="dataHistoricoFormatada" v-on="on" outlined></v-text-field>
															</template>
															<v-date-picker locale="pt-br" v-model="dataHistorico" no-title @input="abrirDatePicker = false"></v-date-picker>
														</v-menu> 
													</v-col>
												</v-row>
											</v-container>
										</v-card-text>
										<v-divider></v-divider>
										<v-card-actions>
											<v-spacer></v-spacer>
											<v-btn @click="salvarNovoHistoricoCla" text color="primary">Confirmar</v-btn>
											<v-btn @click="inserirHistoricoCla = false" text color="primary">Cancelar</v-btn>
										</v-card-actions>
									</v-card>
								</v-dialog>
							</v-card-text>
						</v-tab-item>
						<v-tab-item v-else>
							<v-card-text>
								<OutrosDados />
							</v-card-text>
						</v-tab-item>

						<!-- abas titulos -->
						<v-tab-item v-if="!habilitarEdicao">
							<v-card-text>
								<Titulos :titulos="dadosIniciado"/>
								<v-dialog v-model="editarTitulo" :close-on-content-click="false" max-width="480" scrollable="">
									<v-card color="rgba(255,255,255,1)" height="100%" width="100%" tile>
										<v-toolbar dense flat color="primary"></v-toolbar>
										<v-card-text>
											<v-container>
												<v-row>
													<v-col class="" cols="12">
														<v-text-field label="Nome" v-model="itemTitulo.nome" outlined></v-text-field>
													</v-col>
													<v-col class="" cols="12">
														<v-text-field label="Descrição" v-model="itemTitulo.descricao" outlined></v-text-field>
													</v-col>
													<v-col cols="12">
													<v-menu ref="abrirDataPicker" v-model="abrirDataPicker" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
														<template v-slot:activator="{ on }">
															<v-text-field label="Data Título" v-model="dataTituloFormatada" v-on="on" outlined></v-text-field>
														</template>
														<v-date-picker locale="pt-br" v-model="dataTitulo" no-title @input="abrirDatePicker = false"></v-date-picker>
													</v-menu> 
													</v-col>
												</v-row>
											</v-container>
										</v-card-text>
										<v-divider></v-divider>
										<v-card-actions>
											<v-spacer></v-spacer>
											<v-btn @click="salvarTitulo" text color="primary">Salvar</v-btn>
											<v-btn @click="editarTitulo = false" text color="primary">Cancelar</v-btn>
										</v-card-actions>
									</v-card>
								</v-dialog>

								<v-dialog v-model="excluirItemTitulo" :close-on-content-click="false" max-width="480" scrollable="">
									<v-card color="rgba(255,255,255,1)" height="100%" width="100%" tile>
										<v-toolbar dense flat color="primary"></v-toolbar>
										<v-card-text>
											<v-container>
												<v-row>
													<v-col class="" cols="12">
														<p>Deseja realmente excluir o titulo {{itemTitulo.nome}} para o iniciado {{iniciado.dados.nome}}?</p>
													</v-col>
												</v-row>
											</v-container>
										</v-card-text>
										<v-divider></v-divider>
										<v-card-actions>
											<v-spacer></v-spacer>
											<v-btn @click="excluirTitulo" text color="primary">Confirmar</v-btn>
											<v-btn @click="excluirItemTitulo = false" text color="primary">Cancelar</v-btn>
										</v-card-actions>
									</v-card>
								</v-dialog>
								<v-dialog v-model="inserirTitulo" :close-on-content-click="false" max-width="480" scrollable="">
									<v-card color="rgba(255,255,255,1)" height="100%" width="100%" tile>
										<v-toolbar dense flat color="primary"></v-toolbar>
										<v-card-text>
											<v-container>
												<v-row>
													<v-col class="" cols="12">
														<v-text-field label="Nome" v-model="itemTitulo.nome" outlined></v-text-field>
													</v-col>
													<v-col class="" cols="12">
														<v-text-field label="Descrição" v-model="itemTitulo.descricao" outlined></v-text-field>
													</v-col>
													<v-col cols="12">
													<v-menu ref="abrirDataPicker" v-model="abrirDataPicker" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
														<template v-slot:activator="{ on }">
															<v-text-field label="Data Título" v-model="dataTituloFormatada" v-on="on" outlined></v-text-field>
														</template>
														<v-date-picker locale="pt-br" v-model="dataTitulo" no-title @input="abrirDatePicker = false"></v-date-picker>
													</v-menu> 
													</v-col>
												</v-row>
											</v-container>
										</v-card-text>
										<v-divider></v-divider>
										<v-card-actions>
											<v-spacer></v-spacer>
											<v-btn @click="salvarNovoTitulo" text color="primary">Confirmar</v-btn>
											<v-btn @click="inserirTitulo = false" text color="primary">Cancelar</v-btn>
										</v-card-actions>
									</v-card>
								</v-dialog>
							</v-card-text>
						</v-tab-item>
						<v-tab-item>
							<v-card-text>
								<Acessos :acessos.sync="this.dadosIniciado.acessos"/>
							</v-card-text>
						</v-tab-item>
					</v-tabs>
				</v-container>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions v-if="!this.habilitarEdicao">
				<v-spacer></v-spacer>
				<!-- <v-btn text color="primary" :disabled="buscandoDados"  @click.stop="editarPerfil" v-if="this.aba == 'iniciado'">Editar</v-btn> -->
				<v-btn text color="primary"  v-if="aba == 'acessos'" @click.stop="salvarAcessos()">Salvar Acessos</v-btn>
				<v-btn text color="primary" :disabled="this.iniciado.dados.grauAtual == 7" @click.stop="passarGrau" v-if="this.aba == 'graus' /*&& verificaSePodeAcessar()*/">Novo Grau</v-btn>
				<v-btn text color="primary" @click.stop="mudarCla" v-else-if="this.aba == 'clas' /*&& verificaSePodeAcessar()*/">Novo Clã</v-btn>
				<v-btn text color="primary" @click.stop="cadastrarNovoTitulo" v-else-if="this.aba == 'titulos' /*&& verificaSePodeAcessar()*/">Novo Título</v-btn>
				<v-btn text color="primary" @click.stop="fechar()">Fechar</v-btn>
			</v-card-actions>
			<v-card-actions v-else>
				<v-spacer></v-spacer>
				<v-btn text color="primary" :disabled="buscandoDados"  @click.stop="salvar()">Salvar</v-btn>
				<v-btn text color="primary" :disabled="buscandoDados"  @click.stop="habilitarEdicao = false">Cancelar</v-btn>
				<v-btn text color="primary" @click.stop="fechar()">Fechar</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	import EditarPerfil from '@/components/iniciados/EditarPerfil'
	import Endereco from '@/components/iniciados/Endereco'
	import OutrosDados from '@/components/iniciados/OutrosDados'
	import Clas from '@/components/iniciados/ClasPerfil'
	import Iniciado from '@/components/iniciados/IniciadoPerfil'
	import Passagens from '@/components/iniciados/PassagensPerfil'
	import Titulos from '@/components/iniciados/TitulosPerfil'
	import Acessos from '@/components/iniciados/Acessos'
	import { baseApiUrl, showError, showSuccess } from "@/config/global"
	import axios from 'axios'
	import { mapState } from 'vuex'
	import metodos from '@/mixins/metodos'
	import Br from '@/config/barramento.js'

	export default{
		name: 'Perfil',
		props:['dadosIniciado', 'perfis', 'status', 'paises'],
		computed:{
			... mapState(['user','iniciado', 'buscandoDados', 'listaClas']),
			novoGrau(){
				return parseInt(this.iniciado.dados.grauAtual) + 1
			}
		},
		components: {
			EditarPerfil,
			Endereco,
			OutrosDados,
			Clas,
			Iniciado, 
			Passagens, 
			Titulos,
			Acessos,
		  //Loading
		  },
		mixins:[metodos],
		data(){
			return{
				cor: 'primary',
				aba: 'iniciado',
				salvarNovosAcessos: false,
				habilitarEdicao: false,
				editarPassagem: false,
				excluirPassagem: false,
				inserirNovoGrau: false,
				itemPassagem: {},
				passagens: [],
				titulos: [],
				proprioPerfil: null,
				showPerfil: this.dialog,
				abrirDataPicker: false,
				dataPassagem: '',
				dataPassagemFormatada: '',
				dataHistorico: '',
				dataHistoricoFormatada: '',
				editarHistoricoCla: false,
				excluirHistorico: false,
				inserirHistoricoCla: false,
				itemHistoricoCla: {novoCla: ''},
				itemTitulo: {},
				dataTitulo: '',
				dataTituloFormatada: '',
				editarTitulo: false,
				inserirTitulo: false,
				excluirItemTitulo: false,
				fotoSelecionada: null,
				salvarImagem: false,
				imageFile: null,
				imageUrl: null,
				
			}
		},
		methods:{
			
			uploadImg(){
				this.salvarImagem = false
				this.enviarImagem(this.imageFile, this.imageUrl)
			},
			launchFilePicker(){
				this.$refs.file.click()
				this.salvarImagem = true
			},
			
			onFileSelected(event){
				
				const {maxSize} = this
				this.imageFile = event.target.files[0]

					if(event.target.files.length > 0){
						let size = this.imageFile.size / maxSize / maxSize
						
						if(!this.imageFile.type.match('image.*')){
							this.errorDialog = true
							this.errorText = 'Please choose a image file'
						}else if( size > 1 ){
							this.errorDialog = true
							this.errorText = 'Your file is too big! Please select an image under 1MB'
						}else{
							
							//let formData = new FormData()
							this.imageUrl = URL.createObjectURL(this.imageFile)
							this.iniciado.imagem = this.imageUrl
							//formData.append('file', imageFile)

							//this.enviarImagem(formData, imageUrl)
						}
				}
			},

			enviarImagem(formData, imageUrl){
					
					const url = `${baseApiUrl}/iniciados/iniciado/insereImagem.php`
					
					//let arquivo = formData.get('file')
					let arquivo = this.imageFile
					let img64 = ""
					let inic = this.iniciado.iniciado
					 let reader = new FileReader()
					 reader.onloadend = function(){	
						
						img64 = reader.result

						axios.post(url, {imagem: img64, iniciado: inic})
						.then(res => {
							
							if(res.data.codigo == '01'){
							
								showSuccess(res.data.mensagem)
								this.salvarImagem = false
								// const obj = (JSON.parse(sessionStorage.getItem(userKey)))
								// obj.imagem = img64;
								
								// sessionStorage.setItem(userKey, JSON.stringify(obj))
							}else{
								showError(res.data.mensagem)
							}
						})


					 }

					 reader.readAsDataURL(arquivo)

					this.$store.state.user.imagem = imageUrl
			},

			fechar(){
				this.showPerfil = false
			},
			mudarAba(t){
				this.aba = t
			},
			converterData(dt){
				let data = new Date(dt)
				let difHorario = data.getTimezoneOffset() / 60
				data = new Date(data.setHours(data.getHours() + difHorario))
				return data
			},

			// editarPerfil(){
            //     this.habilitarEdicao = true
			// },

			mudarCla(){
				this.inserirHistoricoCla = true
			},

			passarGrau(){
				this.inserirNovoGrau = true
			},

			cadastrarNovoTitulo(){
				this.inserirTitulo = true
			},

			salvar(){
				const url = `${baseApiUrl}/iniciados/iniciado/update.php`

				axios.post(url, this.iniciado)
				.then(res => {
					if(res.data.codigo == '01'){
						showSuccess(res.data.mensagem)
					}else{
						showError(res.data.meensagem)
					}
				})	
			},

			salvarAcessos(){
				const url = `${baseApiUrl}/iniciados/iniciado/updateAcessos.php`

				axios.post(url, this.iniciado)
				.then(res => {
					if(res.data.codigo == '01'){
						showSuccess(res.data.mensagem)
					}else{
						showError(res.data.meensagem)
					}
				})	
			},

			salvarPassagemGrau(){
		
				const url = `${baseApiUrl}/iniciados/passagemGrau/update.php`
					
					if(this.itemPassagem.dataObj && this.itemPassagem.iniciado){

						axios.post(url, this.itemPassagem)
						.then(res => {
							if(res.data.codigo == '01'){
								showSuccess('Passagem de grau atualizada com sucesso')
							}else{
								showError(res.data.mensagem)
							}

							this.editarPassagem = false
						})
					}else{
						showError("Todos os campos devem ser preenchidos!")
					}	
		
			},

			excluirPassagemGrau(){
                const url = `${baseApiUrl}/iniciados/passagemGrau/delete.php`
                
                axios.post(url, {id: this.itemPassagem.id, grau: this.itemPassagem.grau, id_iniciado: this.itemPassagem.iniciado})
                    .then(res => {
                        
                        if(res.data.codigo == '01'){
                           
                           let idx = this.passagens.findIndex((v, i, a) => {
                                        return v.id == this.itemPassagem.id.id
                                    })

                            this.passagens.splice(idx, 1)

                            showSuccess('Passagem de grau excluida com sucesso')
                           
                        }else{
                            showError(res.data.mensagem)
						}
						
						this.excluirPassagem = false
                    })
			},

			
			
			salvarNovoGrau(){
				
				this.itemPassagem.novoGrau = this.novoGrau
				this.itemPassagem.iniciado = this.iniciado.iniciado

				const url = `${baseApiUrl}/iniciados/passagemGrau/insert.php`
				
				if(this.itemPassagem.novoGrau && this.itemPassagem.dataObj && this.itemPassagem.iniciado){
					
					axios.post(url, this.itemPassagem)
					.then(res => {
				
						if(res.data.codigo == '01'){
							showSuccess('Passagem salva com sucesso')
						}else{
							showError(res.data.mensagem)
						}

						this.inserirNovoGrau = false
					})	
				}else{
					
					showError("Todos os campos devem ser preenchidos!")
				}	
			},

			salvarHistoricoCla(){
				const url = `${baseApiUrl}/iniciados/mudancaCla/update.php`
					
					if(this.itemHistoricoCla.dataObj && this.itemHistoricoCla.iniciado){

						axios.post(url, this.itemHistoricoCla)
						.then(res => {
							if(res.data.codigo == '01'){
								showSuccess('Historico de clã atualizada com sucesso')
							}else{
								showError(res.data.mensagem)
							}
						})
					}else{
						showError("Todos os campos devem ser preenchidos!")
					}
			},

			excluirHistoricoCla(){
                const url = `${baseApiUrl}/iniciados/mudancaCla/delete.php`
                
                axios.post(url, {id: this.itemHistoricoCla.id})
                    .then(res => {
                        if(res.data.codigo == '01'){
                            
                            let idx = this.iniciado.clas.findIndex((v, i, a) => {
                                        return v.id == this.itemHistoricoCla.id
                                    })

                            this.iniciado.clas.splice(idx, 1)

                            showSuccess('Mudança excluida com sucesso')
                            
                        }else{
                            showError(res.data.mensagem)
                        }
                    })
			},
			
			salvarNovoHistoricoCla(){
				this.itemHistoricoCla.iniciado = this.iniciado.iniciado

				const url = `${baseApiUrl}/iniciados/mudancaCla/insert.php`
				
					if(this.itemHistoricoCla.novoCla && this.itemHistoricoCla.dataObj && this.itemHistoricoCla.iniciado){
						axios.post(url, this.itemHistoricoCla)
						.then(res => {
					
							if(res.data.codigo == '01'){
								showSuccess('Mudança salva com sucesso')
							}else{
								showError(res.data.mensagem)
							}
						})	
					}else{
						
						showError("Todossss os campos devem ser preenchidos!")
					}
			},

			salvarTitulo(){
				const url = `${baseApiUrl}/titulos/update.php`
					
					if(this.itemTitulo.dataObj && this.itemTitulo.id && this.itemTitulo.nome && this.itemTitulo.descricao){

						axios.post(url, this.itemTitulo)
						.then(res => {
							if(res.data.codigo == '01'){
								showSuccess('Titulo atualizado com sucesso')
							}else{
								showError(res.data.mensagem)
							}
						})
					}else{
						showError("Todos os campos devem ser preenchidos!")
					}
			},

			excluirTitulo(){
                const url = `${baseApiUrl}/titulos/delete.php`
                
                axios.post(url, {id: this.itemTitulo.id})
                    .then(res => {
                        if(res.data.codigo == '01'){
                            
                            let idx = this.titulos.findIndex((v) => {
										return v.id == this.itemTitulo.id
									})

                            this.titulos.splice(idx, 1)

                            showSuccess('Titulo excluido com sucesso')
                            
                        }else{
                            showError(res.data.mensagem)
                        }
					})
			},
			
			salvarNovoTitulo(){
				this.itemTitulo.iniciado = this.iniciado.iniciado

				const url = `${baseApiUrl}/titulos/insert.php`
				
					if(this.itemTitulo.nome && this.itemTitulo.iniciado && this.itemTitulo.descricao && this.itemTitulo.dataObj){
						axios.post(url, this.itemTitulo)
						.then(res => {
					
							if(res.data.codigo == '01'){
								showSuccess('Titulo salvo com sucesso')
							}else{
								showError(res.data.mensagem)
							}
						})	
					}else{
						
						showError("Todossss os campos devem ser preenchidos!")
					}
			},

			formataDateBr (dt) {
				if (!dt){
					return null
				} 
				const [year, month, day] = dt.split('-')
				const dataTxt = `${day}/${month}/${year}`
				return dataTxt
            },
			
		},

		watch:{
			dataPassagem(val){
				this.dataPassagemFormatada = this.formataDateBr(this.dataPassagem)
				this.itemPassagem.dataObj = this.converterData(this.dataPassagem)
			},
			
			dataHistorico(val){
				this.dataHistoricoFormatada = this.formataDateBr(this.dataHistorico)
				this.itemHistoricoCla.dataObj = this.converterData(this.dataHistorico)
			},

			dataTitulo(val){
				this.dataTituloFormatada = this.formataDateBr(this.dataTitulo)
				this.itemTitulo.dataObj = this.converterData(this.dataTitulo)
			},
		},

		created(){
	
			Br.onFecharEdicaoPerfil(texto => {
				this.modalPerfil = false
			})

			Br.onEditarPassagem(passagem => {
				this.itemPassagem = passagem
				this.editarPassagem = true
				this.dataPassagemFormatada = this.formataDateBr(this.itemPassagem.dataObj.toISOString().substr(0, 10))
			})

			Br.onExcluirPassagem(passagem => {
				this.itemPassagem = passagem
				this.excluirPassagem = true
			})

			Br.onEditarHistoricoCla(cla => {
				this.itemHistoricoCla = cla
				this.editarHistoricoCla = true
				this.dataHistoricoFormatada = this.formataDateBr(this.itemHistoricoCla.dataObj.toISOString().substr(0, 10))
			})

			Br.onExcluirHistoricoCla(cla => {
				this.itemHistoricoCla = cla
				this.excluirHistorico = true
			})

			Br.onEditarTitulo(titulo => {
				this.itemTitulo = titulo
				this.editarTitulo = true
				this.dataTituloFormatada = this.formataDateBr(this.itemTitulo.dataObj.toISOString().substr(0, 10))
			})

			Br.onExcluirTitulo(titulo => {
				this.itemTitulo = titulo
				this.excluirItemTitulo = true
			})

			Br.onAbrirIniciado(abrir => {
				this.showPerfil = true
			})
		}
	}

</script>

<style scoped>
.teste{
	overflow-y: auto;
}
</style>